import React, { useState, useEffect } from 'react';
import { db } from './firebaseConfig';
import { collection, addDoc, getDocs, updateDoc, deleteDoc, doc, onSnapshot } from 'firebase/firestore';
import { TextField, Button, Typography, Box, Paper, IconButton, Divider, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack, Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Grid } from '@mui/material';
import AlertComponent from './AlertComponent';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import ImportarCalendario from './ImportarCalendario';

const AdminPanel = () => {
  const [entries, setEntries] = useState({ abogados: [],  abogadosCompraVenta: [], procesadoras: [], originadores: [] });
  const [newEntry, setNewEntry] = useState({ name: '', email: '', category: 'abogados' });
  const [alert, setAlert] = useState({ open: false, message: '', type: '' });
  const [tabIndex, setTabIndex] = useState(0);
  const [editingEntry, setEditingEntry] = useState(null);

  useEffect(() => {
    const categories = ['abogados', 'abogadosCompraVenta', 'procesadoras', 'originadores'];
    const unsubscribes = categories.map(category => {
      return onSnapshot(collection(db, category), (snapshot) => {
        setEntries(prevEntries => ({
          ...prevEntries,
          [category]: snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        }));
      });
    });

    return () => unsubscribes.forEach(unsub => unsub());
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewEntry({ ...newEntry, [name]: value });
  };

  const handleAddEntry = async () => {
    const category = ['abogados', 'abogadosCompraVenta', 'procesadoras', 'originadores'][tabIndex];
    if (newEntry.name && newEntry.email) {
      try {
        await addDoc(collection(db, category), { name: newEntry.name, email: newEntry.email });
        setNewEntry({ name: '', email: '' });
        setAlert({ open: true, message: 'Elemento agregado exitosamente', type: 'success' });
      } catch (error) {
        setAlert({ open: true, message: 'Error al agregar el elemento', type: 'error' });
      }
    }
  };

  const handleEditEntry = (entry) => {
    setEditingEntry(entry);
  };

  const handleSaveEdit = async () => {
    try {
      const entryDoc = doc(db, ['abogados', 'abogadosCompraVenta', 'procesadoras', 'originadores'][tabIndex], editingEntry.id);
      await updateDoc(entryDoc, { name: editingEntry.name, email: editingEntry.email });
      setAlert({ open: true, message: 'Elemento actualizado exitosamente', type: 'success' });
      setEditingEntry(null);
    } catch (error) {
      setAlert({ open: true, message: 'Error al actualizar el elemento', type: 'error' });
    }
  };

  const [confirmDelete, setConfirmDelete] = useState(false);
  const [deleteCategory, setDeleteCategory] = useState('');
  const [deleteId, setDeleteId] = useState('');

  const handleDeleteEntry = (category, id) => {
    setDeleteCategory(category);
    setDeleteId(id);
    setConfirmDelete(true);
  };

  const confirmDeleteEntry = async () => {
    try {
      const entryDoc = doc(db, deleteCategory, deleteId);
      await deleteDoc(entryDoc);
      setAlert({ open: true, message: 'Elemento eliminado exitosamente', type: 'success' });
      setConfirmDelete(false);
    } catch (error) {
      setAlert({ open: true, message: 'Error al eliminar el elemento', type: 'error' });
    }
  };

  return (
    <Container sx={{ mt: 8, py: 3 }}>
      <Typography variant="h4" gutterBottom align="center">Panel de Administración</Typography>
      {/* <ImportarCalendario /> */}

      <Box sx={{ mt: 2, mb: 2, py: 4, px: 2 }} component={Paper}>

      <Tabs value={tabIndex} onChange={(e, newIndex) => setTabIndex(newIndex)} centered>
        <Tab label="Abogados de Hipoteca" />
        <Tab label="Abogados de Compraventa" />
        <Tab label="Procesadoras" />
        <Tab label="Originadores" />
      </Tabs>
      <Divider sx={{ my:2}} />
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item xs={12} sm={4} md={3}>
            <TextField label="Nombre" name="name" value={newEntry.name} onChange={handleInputChange} fullWidth />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <TextField label="Email" name="email" value={newEntry.email} onChange={handleInputChange} fullWidth />
          </Grid>
          <Grid item xs={12} sm={4} md={3}>
            <Button variant="contained" color="primary" onClick={handleAddEntry} fullWidth>
              Agregar Nuevo
            </Button>
          </Grid>
        </Grid>
      </Box>

      {['abogados', 'abogadosCompraVenta', 'procesadoras', 'originadores'].map((category, index) => (
        tabIndex === index && (
          <TableContainer component={Paper} sx={{ mt: 2 }} key={category}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell align="right">Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {entries[category].map(entry => (
                  <TableRow key={entry.id}>
                    <TableCell>{editingEntry?.id === entry.id ? (
                      <TextField value={editingEntry.name} onChange={(e) => setEditingEntry({ ...editingEntry, name: e.target.value })} fullWidth />
                    ) : (
                      entry.name
                    )}</TableCell>
                    <TableCell>{editingEntry?.id === entry.id ? (
                      <TextField value={editingEntry.email} onChange={(e) => setEditingEntry({ ...editingEntry, email: e.target.value })} fullWidth />
                    ) : (
                      entry.email
                    )}</TableCell>
                    <TableCell align="right">
                      {editingEntry?.id === entry.id ? (
                        <>
                          <IconButton color="primary" onClick={handleSaveEdit}><SaveIcon /></IconButton>
                          <IconButton color="secondary" onClick={() => setEditingEntry(null)}><CancelIcon /></IconButton>
                        </>
                      ) : (
                        <>
                          <IconButton color="primary" onClick={() => handleEditEntry(entry)}><EditIcon /></IconButton>
                          <IconButton color="error" onClick={() => handleDeleteEntry(category, entry.id)}><DeleteIcon /></IconButton>
                        </>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )
      ))}

      <AlertComponent
        open={alert.open}
        message={alert.message}
        type={alert.type}
        handleClose={() => setAlert({ ...alert, open: false })}
      />

      <Dialog open={confirmDelete} onClose={() => setConfirmDelete(false)}>
        <DialogTitle>Confirmación</DialogTitle>
        <DialogContent>
          <DialogContentText>¿Estás seguro de que deseas eliminar este elemento?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmDelete(false)} color="primary">Cancelar</Button>
          <Button onClick={confirmDeleteEntry} color="error" autoFocus>Confirmar</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default AdminPanel;
